// Evenly distributes a string across an interval
// EX: hashUserid("kalsjd324lkjsasdjilk2-2394djkla", 100) will turn the userId into a number between 1-100
// guaranteed to be deterministic
export const hashId = async (identifier: string, interval: number): Promise<number> => {
    const msgUint8 = new TextEncoder().encode(identifier);
    const digest = await window.crypto.subtle.digest("SHA-1", msgUint8);
    const hex = Math.abs(new DataView(digest).getInt32(0));
    return (hex % interval) + 1;
};
